import { IonCardContent, IonCol, IonGrid, IonItem, IonLabel, IonRow, IonText } from '@ionic/react';
import { ClockingDirection } from '../../../models/dms/clocking.model';
import { useAppSelector } from '../../../store/hooks';

interface IComponentProps {
  simpleType?: boolean;
  allowRipple?: boolean;
  handleClick?: () => void;
}

const LabourClockingCardContent: React.FC<IComponentProps> = ({ handleClick, simpleType = false, allowRipple = true, }) => {
  const { labourClocking } = useAppSelector(state => state.technicianClocking);

  return (
    (() => {
      switch (labourClocking?.direction) {
        case ClockingDirection.On:
          return <IonCardContent>
            <IonGrid>
              {/* Labour clocking */}
              {!labourClocking.jobData.isAdhoc &&
                <IonRow>
                  <IonCol>
                    <IonItem>
                      <IonLabel className="ion-text-nowrap" position="stacked" color="dark">Repair Order</IonLabel>
                      <IonText className="ion-text-nowrap">{labourClocking.jobData?.branchCode} / {labourClocking.jobData?.repairOrderNumber}</IonText>
                    </IonItem>
                  </IonCol>
                  <IonCol>
                    <IonItem>
                      <IonLabel className="ion-text-nowrap" position="stacked" color="dark">Job</IonLabel>
                      <IonText className="ion-text-nowrap">{labourClocking.jobData?.jobType} / {labourClocking.jobData?.jobCode}</IonText>
                    </IonItem>
                  </IonCol>
                </IonRow>}
              {/* Adhoc clocking */}
              {labourClocking.jobData.isAdhoc &&
                <IonRow>
                  <IonCol>
                    <IonItem>
                      <IonLabel className="ion-text-nowrap" position="stacked" color="dark">Customer</IonLabel>
                      <IonText className="ion-text-nowrap">{labourClocking.repairOrder.driver.name}</IonText>
                    </IonItem>
                  </IonCol>
                  <IonCol>
                    <IonItem>
                      <IonLabel className="ion-text-nowrap" position="stacked" color="dark">Repair Order</IonLabel>
                      <IonText className="ion-text-nowrap">{labourClocking.jobData.repairOrderNumber}</IonText>
                    </IonItem>
                  </IonCol>
                  <IonCol>
                    <IonItem>
                      <IonLabel className="ion-text-nowrap" position="stacked" color="dark">Rego</IonLabel>
                      <IonText className="ion-text-nowrap">{labourClocking.repairOrder.registrationNumber}</IonText>
                    </IonItem>
                  </IonCol>
                  <IonCol>
                    <IonItem>
                      <IonLabel className="ion-text-nowrap" position="stacked" color="dark">Vehicle</IonLabel>
                      <IonText className="ion-text-nowrap">{labourClocking.repairOrder.vehicle.description}</IonText>
                    </IonItem>
                  </IonCol>
                  <IonCol>
                    <IonItem>
                      <IonLabel className="ion-text-nowrap" position="stacked" color="dark">VIN</IonLabel>
                      <IonText className="ion-text-nowrap">{labourClocking.repairOrder.vehicle.vin || ''}</IonText>
                    </IonItem>
                  </IonCol>
                </IonRow>}
            </IonGrid>
          </IonCardContent>;
        case ClockingDirection.Break:
          return <IonCardContent>
            <IonGrid>
              {/* Labour clocking */}
              {!labourClocking.jobData.isAdhoc &&
                <IonRow>
                  <IonCol>
                    <IonItem>
                      <IonLabel className="ion-text-nowrap" position="stacked" color="dark">Repair Order</IonLabel>
                      <IonText className="ion-text-nowrap">{labourClocking.jobData?.branchCode} / {labourClocking.jobData?.repairOrderNumber}</IonText>
                    </IonItem>
                  </IonCol>
                  <IonCol>
                    <IonItem>
                      <IonLabel className="ion-text-nowrap" position="stacked" color="dark">Job</IonLabel>
                      <IonText className="ion-text-nowrap">{labourClocking.jobData?.jobType} / {labourClocking.jobData?.jobCode}</IonText>
                    </IonItem>
                  </IonCol>
                </IonRow>}
              {/* Adhoc clocking */}
              {labourClocking.jobData.isAdhoc &&
                <IonRow>
                  <IonCol>
                    <IonItem>
                      <IonLabel className="ion-text-nowrap" position="stacked" color="dark">Customer</IonLabel>
                      <IonText className="ion-text-nowrap">{labourClocking.repairOrder.driver.name}</IonText>
                    </IonItem>
                  </IonCol>
                  <IonCol>
                    <IonItem>
                      <IonLabel className="ion-text-nowrap" position="stacked" color="dark">Repair Order</IonLabel>
                      <IonText className="ion-text-nowrap">{labourClocking.jobData.repairOrderNumber}</IonText>
                    </IonItem>
                  </IonCol>
                  <IonCol>
                    <IonItem>
                      <IonLabel className="ion-text-nowrap" position="stacked" color="dark">Rego</IonLabel>
                      <IonText className="ion-text-nowrap">{labourClocking.repairOrder.registrationNumber}</IonText>
                    </IonItem>
                  </IonCol>
                  <IonCol>
                    <IonItem>
                      <IonLabel className="ion-text-nowrap" position="stacked" color="dark">Vehicle</IonLabel>
                      <IonText className="ion-text-nowrap">{labourClocking.repairOrder.vehicle.description}</IonText>
                    </IonItem>
                  </IonCol>
                  <IonCol>
                    <IonItem>
                      <IonLabel className="ion-text-nowrap" position="stacked" color="dark">VIN</IonLabel>
                      <IonText className="ion-text-nowrap">{labourClocking.repairOrder.vehicle.vin || ''}</IonText>
                    </IonItem>
                  </IonCol>
                </IonRow>}
            </IonGrid>
          </IonCardContent>;
        default:
          return <IonCardContent style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <h1>Search Jobs</h1>
          </IonCardContent>;
      }
    })()
  );
};

export default LabourClockingCardContent;
